import * as httpTool from '../http-tools'
import * as apiConst from '../api-const'
export default {
    //婴儿护理操作记录表添加
    addBabyCareOperaData (params) {
        return httpTool.fetchPost(apiConst.addBabyCareOperaDataUrl,params)
    },
    //婴儿护理操作记录表查询list数据
    getBabyCareOperalist (params) {
        return httpTool.fetchPost(apiConst.getBabyCareOperalistUrl,params)
    },
    //婴儿护理操作记录表详情数据
    getBabyCareOperaFind (params) {
        return httpTool.fetchPost(apiConst.getBabyCareOperaFindUrl,params)
    },
    //婴儿护理操作记录表数据更新
    updateBabyCareOperaData (params) {
        return httpTool.fetchPost(apiConst.updateBabyCareOperaDataUrl,params)
    },
    //婴儿护理记录单（1）添加
    addBabyNursOneData (params) {
        return httpTool.fetchPost(apiConst.addBabyNursOneDataUrl,params)
    },
    //婴儿护理记录单（1）查询list数据
    getBabyNursOneDataList (params) {
        return httpTool.fetchPost(apiConst.getBabyNursOneDataListUrl,params)
    },
    //婴儿护理记录单（1）详情数据
    getBabyNursOneFind (params) {
        return httpTool.fetchPost(apiConst.getBabyNursOneFindUrl,params)
    },
    //婴儿护理记录单（1）数据更新
    updateBabyNursOneData (params) {
        return httpTool.fetchPost(apiConst.updateBabyNursOneDataUrl,params)
    },
    //婴儿护理记录单（2）添加
    addBabyNursTwoData (params) {
        return httpTool.fetchPost(apiConst.addBabyNursTwoDataUrl,params)
    },
    //婴儿护理记录单（2）查询list数据
    getBabyNursTwoDataList (params) {
        return httpTool.fetchPost(apiConst.getBabyNursTwoDataListUrl,params)
    },
    //婴儿护理记录单（2）详情数据
    getBabyNursTwoFind (params) {
        return httpTool.fetchPost(apiConst.getBabyNursTwoFindUrl,params)
    },
    //婴儿护理记录单（2）数据更新
    updateBabyNursTwoData (params) {
        return httpTool.fetchPost(apiConst.updateBabyNursTwoDataUrl,params)
    },
    //婴儿喂养记录单添加
    addBabyFeedingRecordData (params) {
        return httpTool.fetchPost(apiConst.addBabyFeedingRecordDataUrl,params)
    },
    //婴儿喂养记录单查询list数据
    getBabyFeedingRecordList (params) {
        return httpTool.fetchPost(apiConst.getBabyFeedingRecordListUrl,params)
    },
    //婴儿喂养记录单详情数据
    getBabyFeedingRecordFind (params) {
        return httpTool.fetchPost(apiConst.getBabyFeedingRecordFindUrl,params)
    },
    //婴儿喂养记录单数据更新
    updateBabyFeedingRecordData (params) {
        return httpTool.fetchPost(apiConst.updateBabyFeedingRecordDataUrl,params)
    },
    //产妇每日生理护理记录添加
    addMaternalEverydayPhysiology (params) {
        return httpTool.fetchPost(apiConst.addMaternalEverydayPhysiologyUrl,params)
    },
    //产妇每日生理护理记录查询list数据
    getMaternalEverydayPhysiologyList (params) {
        return httpTool.fetchPost(apiConst.getMaternalEverydayPhysiologyListUrl,params)
    },
    //产妇每日生理护理记录详情数据
    getMaternalEverydayPhysiologyFind (params) {
        return httpTool.fetchPost(apiConst.getMaternalEverydayPhysiologyFindUrl,params)
    },
    //产妇每日生理护理记录数据更新
    updateMaternalEverydayPhysiology (params) {
        return httpTool.fetchPost(apiConst.updateMaternalEverydayPhysiologyUrl,params)
    },
    //产妇膳食记录添加
    addMaternalMealRecordsData (params) {
        return httpTool.fetchPost(apiConst.addMaternalMealRecordsDataUrl,params)
    },
    //产妇膳食记录查询list数据
    getMaternalMealRecordsList (params) {
        return httpTool.fetchPost(apiConst.getMaternalMealRecordsListUrl,params)
    },
    //产妇膳食记录详情数据
    getMaternalMealRecordsFind (params) {
        return httpTool.fetchPost(apiConst.getMaternalMealRecordsFindUrl,params)
    },
    //产妇膳食记录数据更新
    updateMaternalMealRecordsData (params) {
        return httpTool.fetchPost(apiConst.updateMaternalMealRecordsDataUrl,params)
    },
    //产妇康复护理评估记录单添加
    addMaterRehNursEvalData (params) {
        return httpTool.fetchPost(apiConst.addMaterRehNursEvalDataUrl,params)
    },
    //产妇康复护理评估记录单查询list数据
    getMaterRehNursEvalList (params) {
        return httpTool.fetchPost(apiConst.getMaterRehNursEvalListUrl,params)
    },
    //产妇康复护理评估记录单详情数据
    getMaterRehNursEvalFind (params) {
        return httpTool.fetchPost(apiConst.getMaterRehNursEvalFindUrl,params)
    },
    //产妇康复护理评估记录单数据更新
    updateMaterRehNursEvalData (params) {
        return httpTool.fetchPost(apiConst.updateMaterRehNursEvalDataUrl,params)
    },
}


// WEBPACK FOOTER //
// ./src/service/api/repository/bbForm-api.js